export default __webpack_public_path__ + "static/media/markerYellow.5c45a968.svg";